// =============================================================================
// CONFIGURACAO DAS REPLICAS — EDITE AQUI
// =============================================================================
// Cada replica e uma "view" filtrada do app, acessada por URL /{slug}.
// Slug = chave abaixo (ex: bhaz -> /bhaz).
//
// Filtros disponíveis em cada replica:
//   empresaNome           — empresa emissora (obrigatório pra filtrar)
//   unidadeNegocioNome    — opcional. Se preenchido + empresaNome, o
//                           filtro fica MAIS restrito: só solicitações
//                           dessa unidade dentro daquela empresa.
//                           Ex: ETUS / CORBAN — só ve as do CORBAN.
//   temaCor               — opcional. Cor de accent do app no modo replica
//                           (telas de login/acesso negado tambem usam,
//                           porque essas rodam ANTES do app carregar a
//                           empresa do DB). Valores: 'azul' | 'verde' |
//                           'laranja' | 'preto'. Se nao preenchido, mantem
//                           o verde ETUS default. Quando logado, o app
//                           sobrescreve com o tema_cor real do DB.
//   legacyUrl             — opcional. Link do app antigo daquela empresa
//                           especifica. Aparece como "Versão anterior" no
//                           menu lateral abaixo de Empresas/Unidades.
//                           Troque o placeholder 'ei johnny' pela URL real
//                           (deve comecar com http:// ou https://). Se
//                           ficar com o placeholder, o item nao aparece.
//   logoId                — opcional. ID do arquivo no Google Drive da
//                           logo da empresa (mesmo padrao de APP_LOGO_DRIVE_ID
//                           em constants.js). Usado na TELA DE LOGIN da
//                           replica — pre-login a gente nao tem acesso ao
//                           empresa.logo_url do DB, entao a config aqui e
//                           a fonte. Pos-login, o AppHeader continua usando
//                           o logo_url da empresa do DB (autoritativo).
//                           Troque 'ei johnny' pelo ID real.
//   freeEmpresaSelect     — opcional, default false. Quando true:
//                           a) o picker de empresa emissora no form de
//                              solicitacao fica LIBERADO (usuario escolhe
//                              qualquer empresa cadastrada).
//                           b) o filtro de visualizacao usa replica_origem
//                              em vez de empresa_id: a replica so mostra
//                              as solicitacoes feitas DENTRO dela mesma,
//                              mesmo que sejam pra empresas distintas.
//                           c) emissoes feitas aqui NAO vazam pra outras
//                              replicas que possam ter a mesma empresa.
//                           Empresas/tomadores/unidades cadastradas ficam
//                           todas visiveis (nao filtra por empresa). Use
//                           pra "centrais" tipo LLCs que emitem pra varias
//                           pessoas juridicas.
//
// Comparacao e case-insensitive contra razao_social/nome_fantasia (empresa)
// e contra nome (unidade_negocio).
//
// Pra apontar uma replica:
//   1. Edite empresaNome (e opcionalmente unidadeNegocioNome).
//   2. Edite label pra um nome amigavel.
//   3. Se quiser, renomeie a chave (slug = URL) — mas lembre de
//      atualizar admin-etus apps.config.js subprojects pra liberar acesso.
//   4. Commit + redeploy.
// =============================================================================

export const REPLICAS = {
  bhaz: {
    label: 'BHAZ',
    empresaNome: 'BRAZ COMUNICACAO LTDA.',
    unidadeNegocioNome: '',
    temaCor: 'laranja',
    legacyUrl: 'https://www.appsheet.com/start/5737c9c9-d987-4d0b-9d28-c36d844c54d0',
    logoId: '10dfWE76eMHijraYEkI48ldGyWszyogGm',
    // Apresentacao de onboarding hospedada no proprio dominio (public/).
    // Abre em nova aba quando o user clica no item da sidebar.
    onboardingUrl: '/onboarding-bhaz.html',
    // Override do display name do remetente do email do espelho. So muda o
    // "nome" que aparece na inbox — o endereco real continua sendo o
    // RESEND_FROM (contasareceber@etus.com.br), ate o dominio bhaz.com.br
    // ser verificado no Resend.
    emailFromName: 'FATURAMENTO BHAZ',
    // Prefixo do assunto do espelho. Vira "Nota fácil BHAZ · {Emissora} · {Codigo}".
    // Se vazio/undefined, cai no padrao "Solicitação de NF".
    emailSubjectPrefix: 'Nota fácil BHAZ',
    // Assunto do email do espelho usa PI da solicitacao em vez do
    // codigo interno OS-XXXXXXXX. No email de NF emitida, appenda
    // '· PI <numero>' ao final. Ex:
    //   Espelho:    'Nota fácil BHAZ · BRAZ → ACME · PI 0993930'
    //   NF emitida: 'Nota fiscal emitida · BRAZ → ACME · NF 1989 · PI 0993930'
    // Se a PI da solicitacao estiver vazia, faz fallback pro codigo OS-XXX.
    usePIInSubject: true,
    // Sobe o botao 'Confirmo o recebimento da NF' pra logo abaixo do
    // 'Abrir arquivo da nota fiscal' — melhora engajamento (antes o
    // botao ficava enterrado no final do email, cliente nunca chegava
    // ate la). Some tambem com o card duplicado do rodape.
    showReceiptCTAOnTop: true,
    // Mostra o aviso destacado de "confira a forma de pagamento" no espelho
    // (PDF e email). So aparece em replicas que ligaram essa flag. Decisao
    // de negocio pediu pra ficar so BHAZ por enquanto.
    showAvisoFormaPagamento: true,
    // No modo Exterior, libera PTAX e Valor em US$ como opcionais e
    // permite o usuario digitar o Valor (R$) diretamente. Quando preencher
    // PTAX + US$, o auto-calculo continua funcionando normal. So BHAZ.
    freeExteriorValue: true,
    // Oculta os controles de recorrencia/parcelamento no form de criacao
    // (so deixa o lancamento unico). Pra reativar no futuro, eh so apagar
    // esta linha — a logica do servidor e o estado do form continuam ai,
    // so o picker fica escondido.
    hideSerieControls: true,
    // Substitui o "Documento auxiliar" por 2 slots complementares
    // (Doc complementar 1 e 2). BHAZ tem cenario onde o usuario anexa
    // contratos + prints e precisa de 2 slots separados.
    // OBS: useDocsAuxiliaresMulti abaixo tem prioridade — se ambos
    // estiverem true, so o multi eh renderizado.
    useAnexosComplementares: true,
    // Layout NOVO: substitui Doc auxiliar + Relatorios + Cartas por UM
    // slot que aceita multiplos PDFs (documentos_auxiliares jsonb).
    // Cada arquivo eh mostrado no email como link clicavel com o nome
    // real do arquivo. Prioriza sobre useAnexosComplementares.
    useDocsAuxiliaresMulti: true,
    // BHAZ-only: layout laranja pra Nota fiscal + PI (uso interno)
    // lado a lado. Renderiza os 2 campos em cards laranja pra dar
    // destaque visual. Se falso, Nota fica sem destaque e o PI vira
    // 'Documento auxiliar' padrao.
    useNotaPILayout: true,
    // Comprime PDFs no browser ANTES de subir (flatten via pdf-lib +
    // pdfjs-dist). Reduz 60-90% em PDFs de imagem — cenario tipico
    // BHAZ. Perde texto selecionavel; user aceitou o tradeoff.
    compressPdfUploads: true,
    // Libera cadastro de tomador Pessoa Fisica (CPF) alem de PJ (CNPJ)
    // e Exterior. Adiciona uma 3a aba 'PF' no toggle do form de tomador
    // e valida CPF de verdade (digitos verificadores). Empresa emissora
    // continua sempre PJ. Ao editar tomador ja cadastrado, o form detecta
    // PF pela quantidade de digitos do documento (11 = CPF, 14 = CNPJ).
    allowTomadorPF: true,
  },
  supersonic: {
    label: 'SUPERSONIC',
    empresaNome: 'ETUS MEDIA HOLDING LTDA',
    unidadeNegocioNome: 'Supersônic',
    temaCor: 'verde',
    legacyUrl: 'https://www.appsheet.com/start/1mWVkC1OZ4jmwAv63_tY8QZlCTfhMMxsb',
    logoId: '1-76sPwLxmwzY2PKo14_3YVZZ2ZF3bruX',
    onboardingUrl: '/onboarding-supersonic.html',
    // Desativa (nao esconde) o botao 'Enviar por e-mail' do espelho.
    // Supersonic nao manda espelho pro cliente por enquanto — pode ser
    // ligado de volta tirando este campo daqui.
    disableEspelhoEmail: true,
  },
  llcs: {
    label: 'LLCs',
    empresaNome: 'ETUS DIGITAL LLC',
    unidadeNegocioNome: '',
    temaCor: 'azul',
    legacyUrl: 'https://www.appsheet.com/start/d9c1c439-babe-4c1b-a374-b41706ba8c76',
    freeEmpresaSelect: true,
    logoId: '1K_9pA9t6MUkGdAOj18bAeMv_F96SEPMP',
    // Forca o form de solicitacao a abrir SEMPRE em modo Exterior (sem
    // toggle Brasil/Exterior visivel). Ativa tambem auto-fetch da PTAX
    // pelo BCB e auto-preenche a descricao com o template padrao LLCs.
    forceExterior: true,
    // Liga o modulo de Fechamento de Cambio (NDF) — substitui o
    // "Resumo Fechamento Dolar.xlsx". Sidebar ganha item "Câmbio" + view
    // dedicada de Home/Form/Detalhe. So aparece em LLCs.
    hasCambioModule: true,
    // Permite anexar VARIOS PDFs num so slot 'Documentos auxiliares'
    // (array jsonb documentos_auxiliares). Substitui o 'Documento auxiliar'
    // single. Cada arquivo vira link clicavel no email da NF emitida.
    // Sem o layout laranja da BHAZ — LLCs mantem visual padrao.
    useDocsAuxiliaresMulti: true,
  },
  plusdin: {
    label: 'PLUSDIN',
    empresaNome: 'PLUSDIN TECNOLOGIA E INFORMACAO LTDA',
    unidadeNegocioNome: '',
    temaCor: 'verde',
    legacyUrl: 'https://www.appsheet.com/start/02edcadb-70ab-4dee-baaf-7cfc063fd6b7',
    logoId: '1UQVauHIPzK1WToJymnxQLa6H5eEwCykr',
    onboardingUrl: '/onboarding-plusdin.html',
    // Libera o picker de empresa emissora + isola visualizacao por
    // replica_origem (nao por empresa_id). Assim ambas ETUS e Plusdin
    // podem ser emissoras nesta replica sem vazamento pra outras.
    freeEmpresaSelect: true,
    // Restringe o dropdown de emissora as duas empresas listadas
    // (match case-insensitive por substring na razao social ou nome
    // fantasia). So aplica quando freeEmpresaSelect eh true.
    emissoraNomes: ['ETUS MEDIA HOLDING', 'PLUSDIN TECNOLOGIA'],
  },
  etusbr: {
    label: 'ETUSBR',
    empresaNome: 'ETUS MEDIA HOLDING LTDA',
    unidadeNegocioNome: '',
    temaCor: '',
    legacyUrl: 'https://www.appsheet.com/start/f3981d48-7f8b-419f-8074-f0d3ca02a971',
    logoId: '1vR1_bezDs3VBUmW5oqqBAcP-iVlxQOIX',
  },
};

export const REPLICA_SLUGS = Object.keys(REPLICAS);

// Helper: dado um slug, retorna a config (ou undefined se nao existir)
export function getReplicaConfig(slug) {
  if (!slug) return undefined;
  return REPLICAS[slug];
}

// Helper: empresa que casa com empresaNome do slug (case-insensitive em
// razao_social ou nome_fantasia).
export function findReplicaEmpresa(slug, empresas) {
  const cfg = getReplicaConfig(slug);
  if (!cfg || !cfg.empresaNome) return undefined;
  const target = cfg.empresaNome.trim().toLowerCase();
  if (!target) return undefined;
  return (empresas || []).find(e =>
    (e.razao_social || '').trim().toLowerCase() === target ||
    (e.nome_fantasia || '').trim().toLowerCase() === target
  );
}

// Helper: unidade de negocio que casa com unidadeNegocioNome do slug
// dentro da empresa resolvida. Retorna undefined se config nao tem
// unidadeNegocioNome ou se nao casar.
export function findReplicaUnidade(slug, empresa, unidades) {
  const cfg = getReplicaConfig(slug);
  if (!cfg || !cfg.unidadeNegocioNome || !empresa) return undefined;
  const target = cfg.unidadeNegocioNome.trim().toLowerCase();
  if (!target) return undefined;
  return (unidades || []).find(u =>
    u.empresa_id === empresa.id &&
    (u.nome || '').trim().toLowerCase() === target
  );
}
